import { render } from "./BillApprovals.vue?vue&type=template&id=ef4d734e&scoped=true"
import script from "./BillApprovals.vue?vue&type=script&lang=js"
export * from "./BillApprovals.vue?vue&type=script&lang=js"

import "./BillApprovals.vue?vue&type=style&index=0&id=ef4d734e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef4d734e"]])

export default __exports__